import { takeLatest, select,call, put } from "redux-saga/effects";
import axios from "axios";
import log from "loglevel";

import getEnvParam from "../../utils/getEnvParam";
import { requestDefaultJson } from './helpers'

const getCdDetailsFromAPi = (id,token) => {
	return requestDefaultJson({
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + "/cd/detalhe/" + id,
		method: "GET", 
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
			"Authorization": token
		},
	});
};

const putCdDetailsFromAPi = (id, horarios, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/cd/editarHorario/" + id, {
			method: "PUT",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization": token
			},
			data: {
				horarios
			}
		})
		.then(response => response.status !== 200 ? reject(response) : response)
		.then(response => response.data)
		.then(response => resolve(response))
		.catch(error => {
			const response = error.response.data
			reject(response);
			log.info(error);
		});
	});
}

// Generators

function* getCdDetails(payload) {
	try {
		
		const authentication = state => state.authentication;
		
		const { token } = yield select(authentication);
		
		const data = yield call(getCdDetailsFromAPi, payload.id, token);
		
		yield put({ type: "CD_DETAILS", payload: data });

	} catch (error) {
		// TODO Este bloco em producao deverah ser melhor tratado e apresentar uma mensagem para o cliente
		log.info(error);
	}

}

function* putCdDetails(payload) {
	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);

		const data = yield call(putCdDetailsFromAPi, payload.id, payload.hours, token);
		
		yield put({ type: "CD_DETAILS_UPDATE", payload: data });

		yield put({ type: "CD_HOUR_SUCCESS", payload:{ success: true, type: 'update' }});

	} catch (error) {

		yield put({ type: "CD_HOUR_ERROR", payload:{ error: true, data: error }});
		
		log.info(error);
	}

}


// Generator function
export function* getCdDetailsWatcher() {
	yield takeLatest("GET_CD_DETAILS", getCdDetails);
	yield takeLatest("PUT_CD_DETAILS", putCdDetails);
}
